import { z } from "zod";

const categoryName = z.object({
  id: z.number(),
  en: z.string().or(z.null()),
  pl: z.string(),
  uk: z.string().or(z.null()),
});

const state = z.enum(["DRAFT", "PUBLISHED", "ARCHIVED"]);

const document = z.object({
  documentId: z.string(),
  priority: z.number(),
  state,
  title: categoryName,
  url: z.string(),
  fileName: z.string(),
  availableFrom: z.string().or(z.null()).optional(),
  availableUntil: z.string().or(z.null()).optional(),
});

const documents = z.object({
  categoryId: z.string(),
  categoryIcon: z.string(),
  state,
  priority: z.number(),
  displayMobile: z.boolean(),
  displayWeb: z.boolean(),
  brand: z.string(),
  categoryName,
  documents: z.array(document),
});

export const serverResponse = z.array(documents);
export type IDocumentLists = z.infer<typeof documents>;
